import React from 'react';
import { useImpressionManager } from '@fiverr-private/impressionable';
import { Box } from '@fiverr-private/theme';
import { useIsClient } from '@fiverr-private/hooks';
import Categories from '../../../apps/logged_out_homepage/components/Categories';
import Seo from '../../../apps/logged_out_homepage/shared/Seo';
import EntryWrapper from '../../../apps/logged_out_homepage/components/EntryWrapper';
import SubcategoryCarousel from '../../../apps/logged_out_homepage/components/SubcategoryCarousel';
import { getSubCategories } from '../../../apps/logged_out_homepage/components/SubcategoryCarousel/config';
import { ROLLOUTS } from '../../../apps/logged_out_homepage/utils/types/rollouts';
import { shouldLoadPersonalizedSection } from '../../../apps/logged_out_homepage/components/PersonalizedSectionWrapper/shouldLoad';
import VideoHeroBannerWrapper from '../../../apps/logged_out_homepage/components/VideoHeroBannerWrapper';
import FiverrGuides from '../../../apps/logged_out_homepage/components/FiverrGuides';
import Signup from '../../../apps/logged_out_homepage/components/Signup';
import PersonalizedSectionWrapper from '../../../apps/logged_out_homepage/components/PersonalizedSectionWrapper';
import Freelancers from '../../../apps/logged_out_homepage/components/Freelancers';
import Video from '../../../apps/logged_out_homepage/components/Video';
import ProBanner from '../../../apps/logged_out_homepage/components/ProBannerSection';
import AiBanner from '../../../apps/logged_out_homepage/components/AiBannerSection';
import Faqs from '../../../apps/logged_out_homepage/components/Faqs';

interface LoggedOutHomepageClientProps {
    userWasLoggedIn?: boolean;
    withEnglishBAL?: boolean;
    rollouts?: Record<string, boolean>;
}

const LoggedOutHomepageClient = ({ userWasLoggedIn, withEnglishBAL, rollouts }: LoggedOutHomepageClientProps) => {
    useImpressionManager();
    const isClient = useIsClient();

    const shouldLoad = isClient ? shouldLoadPersonalizedSection({ userWasLoggedIn }) : false;
    const isTiktokShopActive = Boolean((rollouts || {})[ROLLOUTS.LYNXES_TIKTOK_SHOP_SERVICE]);
    const isBelowTheFoldActive = Boolean((rollouts || {})[ROLLOUTS.LYNXES_LOHP_BELOW_THE_FOLD]);

    return (
        <EntryWrapper withEnglishBAL={withEnglishBAL} isTiktokShopActive={isTiktokShopActive}>
            <Seo />
            <Box paddingBottom={{ default: '10', md: '7' }}>
                <VideoHeroBannerWrapper />
            </Box>
            <Categories />
            {shouldLoad && <PersonalizedSectionWrapper />}
            <SubcategoryCarousel subCategories={getSubCategories(withEnglishBAL, isTiktokShopActive)} />
            <Freelancers />
            <ProBanner />
            <AiBanner />
            <Video />
            <FiverrGuides />
            {isBelowTheFoldActive && <Faqs />}
            <Signup />
        </EntryWrapper>
    );
};

export default LoggedOutHomepageClient;
